<template>
  <li
    v-editable="blok"
    :class="[spaceBetweenItems, computedFontStyle, computedTextColor]"
    :style="image?.filename ? { '--bullet-img-url': `url(${image.filename})` } : {}"
  >
    <template v-if="blok.multi_text && blok.multi_text.length !== 0">
      <StoryblokComponent
        v-for="childBlok in blok.multi_text"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </template>
    <span v-else class="mb-0">
      {{ decodedText }}
    </span>
  </li>
</template>

<script lang="ts" setup>
import useTextModifiers from '@/composables/useTextModifiers'
import type { AssetStoryblok, SbListItemStoryblok, SbPluginInfermedicaFontPicker } from '@/types'

const { decodeAndReplaceText } = useTextModifiers()

interface Props {
  blok: SbListItemStoryblok
  space: string
  font: SbPluginInfermedicaFontPicker | void
  image?: AssetStoryblok
}
const props = withDefaults(defineProps<Props>(), {
  space: '4',
})

const spaceBetweenItems = computed(() => `mb-${props.space}`)
const computedFontStyle = computed(() => props.font?.font.value ?? 'paragraph--m')
const computedTextColor = computed(() => props.font?.color_name ? `text-${props.font.color_name}` : '')
const decodedText = computed(() => props.blok.text && decodeAndReplaceText(props.blok.text))
</script>
